import React from 'react'
import { Helmet } from 'react-helmet';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  return (
    <div>
      <Helmet>
        <title>Contact Us</title>
        <meta name="description" content="We welcome inquiries, feedback, and collaboration opportunities. Get in touch with us."/>
      </Helmet>
      <div className='main-container'>
        <header id="section-head">
          <div className="section-banner-content">
            <h1>Contact Us</h1>
          </div>
        </header>
        <div className="section">
          <div className="section-sub-heading">
            <h1>Get in Touch</h1>
          </div>
          <div className="grid-2">
            <div>

              <ContactForm />
            </div>
            <div className="contact-address">
              <p> Address:
                AB-4/326,<br /> Indian Institute of Technology Gandhinagar,<br />
                Palaj, Gandhinagar, Gujarat, PIN - 382355.<br />
                {/* email: waterclimateiitgn@gmail.com */}
              </p>

            </div>

          </div>

        </div>
      </div>

      <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14667.476938056565!2d72.6842282!3d23.2114357!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395c2b1fe336f123%3A0xbc2d7986e8461012!2sWater%20%26%20Climate%20Lab.!5e0!3m2!1sen!2sin!4v1676795166709!5m2!1sen!2sin" width="100%" height="400" style={{ border: 0 }} allowFullScreen="" aria-hidden="false" tabIndex={0}
        referrerPolicy="no-referrer-when-downgrade" title='Google Map'>
      </iframe>
    </div>

  )
}

export default Contact